<div class="cards-container">
  <google-map [center]="center" [zoom]="zoom" [height]="'100%'" [width]="'100%'">
    <map-marker *ngFor="let marker of markers" [position]="marker.position" [title]="marker.title" [icon]="marker.statusAsset.icon"
      (mapClick)="openInfoWindow(marker)">
    </map-marker>
    <map-info-window>{{ selectedPosition | json }}</map-info-window>
  </google-map>
</div>
